import { createSlice } from '@reduxjs/toolkit';
import { optionsValueType, selectedStudyOptions } from 'src/@types/viability/viabilityStudy';

type CalculatorState = {
	isLoading: boolean,
	error: Error | string | null,
	totalValue: number,
	isSaveValue: boolean,
	selectedOptions: selectedStudyOptions,
	optionsValue: optionsValueType
};

const initialState: CalculatorState = {
	isLoading: false,
	error: null,
	totalValue: 0,
	isSaveValue: false,
	selectedOptions: {
		completeEvu: false,
		directorPlan: false,
		concept: false,
		dwgStudy: false,
		downloadStudy: false
	},
	optionsValue: {
		completeEvu: 0,
		directorPlan: 0,
		concept: 0,
		dwgStudy: 0,
		downloadStudy: 0
	}
};

const slice = createSlice({
	name: 'calculator',
	initialState,
	reducers: {
		startLoading(state) {
			state.isLoading = true;
		},
		stopLoading(state) {
			state.isLoading = false;
		},
		hasError(state, action) {
			state.isLoading = false;
			state.error = action.payload;
		},
		setTotalValue(state, action) {
			state.totalValue = action.payload;
		},
		setIsSaveValue(state, action) {
			state.isSaveValue = action.payload;
		},
		setSelectedOptions(state, action) {
			state.selectedOptions = action.payload;
		},
		setOptionsValue(state, action) {
			state.optionsValue = action.payload;
		}
	}
})

export const { startLoading, stopLoading, setTotalValue, setIsSaveValue, setSelectedOptions, setOptionsValue } = slice.actions;

export default slice.reducer;